import { BasicLayout } from 'components/layouts/BasicLayout';
import { Provider } from 'react-redux';
import { HEADER_NAV_MENU } from '@doda/pc/src/constants/headerNavMenu';
import { InferGetServerSidePropsType } from 'next';
import { makeStore } from 'redux/store';
import { getServerSideProps } from './getServerSideProps';
import { FeaturedJobListScreen } from './screens/FeaturedJobListScreen';

const FeatureJobList = (
  props: InferGetServerSidePropsType<typeof getServerSideProps>
) => {
  const {
    topicJob,
    isNoPic,
    jobList,
    jobListMeta,
    currentPage,
    featuredId,
    initialSideBarMasterData,
    initialJobCountData,
    modalMasterData,
    featuredSearchCondition,
    validationMessages,
    initialState,
  } = props;

  const store = makeStore({ preloadedState: initialState });

  return (
    <Provider store={store}>
      <BasicLayout selectedNavItem={HEADER_NAV_MENU.SEARCH}>
        <FeaturedJobListScreen
          topicJob={topicJob}
          isNoPic={isNoPic}
          jobList={jobList}
          jobListMeta={jobListMeta}
          currentPage={currentPage}
          featuredId={featuredId}
          initialSideBarMasterData={initialSideBarMasterData}
          initialJobCountData={initialJobCountData}
          modalMasterData={modalMasterData}
          featuredSearchCondition={featuredSearchCondition}
          validationMessages={validationMessages}
        />
      </BasicLayout>
    </Provider>
  );
};

export { getServerSideProps };

export default FeatureJobList;
